import { cn } from "@/lib/cn";

/** Small pill kicker — teal-tinted, sits above section headings. */
export function Eyebrow({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full bg-primary-tint px-3 py-1 text-xs font-bold uppercase tracking-[0.12em] text-primary",
        className,
      )}
    >
      {children}
    </span>
  );
}
